import React, { Component }        from "react";
import { Accordion, Button, PageHeader, FormGroup, InputGroup, FormControl, ListGroup, ListGroupItem, PanelGroup, Panel, Row, Col } from "react-bootstrap";
import uniqueId                    from 'lodash/uniqueId';
import FooterLoadingBar            from "../../components/utils/FooterLoadingBar";
import RenderLander                from "../../components/utils/RenderLander";
import { Colors }                  from "../../utils/Colors";
import YouTubePlayer               from "../../components/YouTubePlayer";
import YouTubeThumbnail            from "../../components/YouTubeThumbnail";
import { invokeGetSearchHelpFAQs } from "../../utils/AwsInvoke";
import "../../css/help/HelpList.css";

export default class Help extends Component {
    constructor(props) {
        super(props);

        //var search_term = `${this.props.match.params.search_term}`;
        //if(search_term === "&") search_term = "";
        // temp
        var search_term = "";
        this.state = {
            isLoading: false,
            numberOfRows: 100,
            helpResults: [],
            searchMsg: "",
            searchTerm: search_term,
            showLoadingBar:"none"
        };
    }

    componentDidMount() {
        this.searchHelpFAQs();
        /* temp remove 6-28-2018 while flying
        if (!this.props.isAuthenticated) {
            return;
        }

        try {
            console.log("Home component mount.");

        } catch (e) {
            alert("Home component: " + e);
        }*/
    }

    handleHelp = () => {
        window.open("https://acceleratesp.typeform.com/to/z7FftD", '_blank');
    }

    handleReport = () => {
        window.open("https://acceleratesp.typeform.com/to/Fx3EDI", '_blank');
    }

    clearSearchField = () => {
        // RESET URL
        //this.props.history.replace("/client/listAll/&")

        this.setState({
            searchTerm: "", // reset search term if resetting member list
        })
    }

    handleKeyPress = (event) => {
        // Allow user to hit "Enter" when using Search box //
         if(event.charCode === 13)
            this.searchHelpFAQs();
    }

    searchHelpFAQs = async () => { //(number_of_rows, sort_by)
        //var search_term = this.state.searchTerm;

        /*if(this.searchInput != undefined) {
            search_term = this.searchInput.value;
            console.log("search_term: " + search_term);
            console.log("search_term.length: " + search_term.length);

            if(search_term.length === 0) search_term = "&";

            //this.props.history.replace("/help/"+search_term)

                console.log("hit me 0.");
            //// RESET Search Textfield
            if(search_term === "&") {
                console.log("hit me 1.");
                this.setState({
                    searchTerm: "", // reset search term if resetting exerc list
                    searchMsg: ""   // clear search message
                }, function () {
                    //this.getExerciseList();
                })
                return
            }
            console.log("search_term: " + search_term);
        }*/
        var search_term = this.searchInput.value;

        const results = await invokeGetSearchHelpFAQs(search_term.toLowerCase()); //, number_of_rows, sort_by);

        if(results) {

            this.setState({
                helpResults: results,
                searchTerm: search_term,
                searchMsg: "You have "+results.length+ " results when searching for '" + search_term + "'.",
                isLoading: false,
                showLoadingBar: "none"
            });
        } else {
            this.setState({
                isLoading: false,
                showLoadingBar: "none"
            });
        }
    }

    renderHelpFAQList(exercises) {

            var search_msg     = "";
            var tmp_search_msg = this.state.searchMsg;
            var help_results = this.state.helpResults;

            if(exercises != null) {
                  var help_arr = [];

                  if(help_results.length === 0) {
                      help_arr.push(<div key={uniqueId()} className="exerciseHeaderButtons">
                                        <span style={{position:"relative", top:"7px", left:"7px", fonySize: "19px"}}>
                                            { tmp_search_msg }
                                        </span>
                                   </div>);
                  } else {
                      for(var key in help_results) {
                              var youtube_id = help_results[key].youtube_id;
                              var youtube_player = "";

                              if(youtube_id != null && youtube_id != "")
                                 youtube_player = <span>
                                                        <div className="helpYouTubeContainer">
                                                             <YouTubePlayer yt_id={youtube_id} />
                                                         </div>
                                                         <div className="helpVerticalSpacer"/>
                                                  </span>

                              help_arr.push(<Panel
                                              key         = {uniqueId()}
                                              className   = "helpPanels"
                                              collapsible
                                              header      = {<span>
                                                                  <span style={{textDecoration: "none", display:"inline-block", width:"100%", padding:0}}>
                                                                      <div className="helpMainBodyAnswerText">
                                                                          { parseInt(key)+1 }. { help_results[key].question }
                                                                      </div>
                                                                  </span>
                                                              </span>}
                                               >
                                                    { youtube_player }
                                                    <span className="helpListSingleRow ">
                                                            <textarea className = "helpListDetails"
                                                                      rows      = { 8 }
                                                                      value     = {help_results[key].answer}
                                                                      readOnly
                                                                   />
                                                    </span>
                                                    <div className="helpPopupIcon"
                                                          onClick={this.handleHelpDetail}
                                                          href={'/help/detail/'+help_results[key].uid} >
                                                        see more &nbsp;
                                                        <span className="glyphicon glyphicon-new-window"/>
                                                    </div>
                                            </Panel>)
                          }
                  }

                  return help_arr;
             }
    }

    handleHelpDetail = event => {
        var link = event.currentTarget.getAttribute("href");
        this.props.history.push(link);
        event.preventDefault();
    }

    renderHelpList() {
        var help_panels =   <PanelGroup className="" style={{position:"relative", cursor: "pointer", top:0, padding:1, borderRadius: 5, width: "100%"}}>
                                {!this.state.isLoading && this.renderHelpFAQList(this.state.helpResults)}
                            </PanelGroup>

        return  (
                <div className="exerciseHeaderSearchBar" style={{display: "inline-block", width:"100%", height:"100%"}} >
                     <span>
                            <FormGroup>
                               <InputGroup>
                                 <FormControl key = {uniqueId()}
                                              type="text"
                                              placeholder=""
                                              defaultValue={this.state.searchTerm}
                                              inputRef={ref => { this.searchInput = ref; }}
                                              onKeyPress={this.handleKeyPress}
                                          />

                                   <span className="glyphicon glyphicon-remove-circle searchInputClearBtn"
                                         onClick={() => this.clearSearchField()}
                                   />
                                   <InputGroup.Button>
                                     <Button style={{ display:"inline-block", height:"34px",backgroundColor: Colors.search_button_bg, color:"white", borderRadiusInputTopRight: "5px" }} onClick={() => this.searchHelpFAQs()}>Search</Button>
                                   </InputGroup.Button>
                               </InputGroup>
                             </FormGroup>
                      </span>
                      <div className="helpMainBody">
                          { help_panels }
                      </div>
                </div>
                )
    }

    renderHelp() {
        return (
          <div className="programs">
            <PageHeader>
                    Help
            </PageHeader>
            <Row className="grid">
                  <Col xs={12} sm={4} md={4}>
                      <span onClick={this.handleHelp}>
                          <span style={{textDecoration: "none"}}>
                             <span className="glyphicon glyphicon-eye-open "></span> General Help Issues
                          </span>
                      </span>
                      <br/>
                  </Col>
                  <Col xs={12} sm={4} md={4}>
                      <span onClick={this.handleReport}>
                          <span style={{textDecoration: "none"}}>
                             <span className="glyphicon glyphicon-fire"></span> Report a Problem
                          </span>
                      </span>
                      <br/><br/>
                  </Col>
              </Row>
              <span style={{display: "inline-block"}}>
                  {!this.state.isLoading && this.renderHelpList()}
              </span>
          </div>
        );
    }

    render() {
        return (
              <div className="Home">
                { /* /* temp remove 6-28-2018 while flying
                    this.props.isAuthenticated ? this.renderHelp() : <RenderLander />
                    */}
                { this.renderHelp() }

                <FooterLoadingBar text={"Retieving Members ..."}
                                  showLoadingBar={this.state.showLoadingBar}
                />
              </div>
        );
  }
}



// WEBPACK FOOTER //
// ./src/screens/help/HelpList.js